/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
    	  $("a.a-hover").hover(function() {
    		  $(this).css('color','#00a199');
    		});
        // JavaScript to be fired on all pages
        var $wWidth = $(window).width(),
            $wHeight = $(window).height();
        
        $(window).on('resize', function() {
            $windowWidth = $(this).width();
            if ($windowWidth <= 767) {
            	$('.pull-right-margin').css({'margin-right':'54px','margin-top':'0px'});
            } else if($windowWidth >= 767 && $windowWidth <= 991){
            	$('.pull-right-margin').css({'margin-right':'54px','margin-top':'70px'});
            }else{
            	$('.pull-right-margin').css({'margin-right':'54px','margin-top':'70px'});
            }
            
            
//            $('.windowWidth').html('');
//            $('body').append('<div class="windowWidth">width: '+$windowWidth+'</div>');
//            $('.windowWidth').css({'background':'yellow','color':'red','position': 'fixed','left': '200px','top':'0px','z-index': '1000' ,'display': 'block'});
            
            
        });
        $('.border-pricing').css({
        	'border-bottom':'1px solid #eeeeee',
            'height':'1px',
            'clear':'both',
            'padding':'0px',
            'width':'50%',
            'margin':'0px auto 20px auto'
        });
        if ($wWidth < 763) {
        	$('.fix-experience-block').css({'margin-top':'-40px'});
        	$('.fix-about-sinet').css({'display':'block','float':'left','text-align':'left'});
        	$('.fix-how-it-work').css({'margin':'0px 0px 80px 0px'});
        	$('.fix-how-it-work > p.pusher').css({'margin-bottom':'-25px','margin-top':'0px'});
        	$('.border-right, .border-right-table').css({'border-right':'none'})
        	$('.border-right-table, .border-right-table-2').css({'padding':'0px 0px 20px 0px'});
        }

        $("#menu-main-menu > .menu-item").each(function() {
          $("div.selected-menu-item", this).offset({
            left: $(this).offset().left + (($(this).width() / 2) - 28)
          });
        });

        $('li.menu-item-has-children>a').click(function(e) {
          e.preventDefault();
        });

        if ($wWidth <= 767) {
        	$('.pull-right-margin').css({'margin-right':'54px','margin-top':'0px'});
          var open = false;
          $('.menu-toggle').click(function() {
            if (open === false) {
              $('ul#menu-main-menu').slideDown();
              open = true;
            } else {
              $('ul#menu-main-menu').slideUp();
              open = false;
            }
          });


          $('li.menu-item-has-children').click(function() {
            var currentClick = $(this).attr('id');
            var currentClickOpen = false;
            $('li.menu-item-has-children').each(function() {
              if ($(this).children('.custom-sub').hasClass('open')) {
                $(this).children('.custom-sub').removeClass('open').slideUp();
                if ($(this).attr('id') === currentClick) {
                  currentClickOpen = true;
                }
              }
            });
            if (currentClickOpen === false) {
              $(this).children('.custom-sub').addClass('open').slideDown();
            }
          });
      } else if($wWidth >= 767 && $wWidth <= 991){
      $('.pull-right-margin').css({'margin-right':'54px','margin-top':'70px'});
          //tablet specific js
      }else{
      		$('.pull-right-margin').css({'margin-right':'54px','margin-top':'70px'});
            /*if ($('.sub-page-header').length) {
                var hMinusMenu = $wHeight - (80 + 15 + 15 + 100);
                //$('.sub-page-header').height(hMinusMenu);
            }*/

            //affix sub menu
            $(window).scroll(function(){
                if($(this).scrollTop() >= 95){
                    $('.fixed-sub-nav').css({
                        'position':'fixed',
                        'top':'0',
                        'width':'100%',
                        'z-index':'1000'
                    });
                    if($('.sub-page-header').length){
                        $('.sub-page-header').css('margin-top','84px');
                    }else{
                        $('.dynamic-content').css('margin-top','84px');
                    }

                    //$('.fixed-sub-nav>.custom-sub').css('height','84px');
                   /* $('ul.sub-menu').css('margin-top','10px');*/
                    //if($('.fixed-sub-nav').css('position') == 'fixed'){
                        //$('.fixed-sub-nav .custom-sub i.snicon').css('font-size','40px');
                    //}else{
                    //    $('.fixed-sub-nav .custom-sub i.snicon').css('font-size','50px');
                    //}
                }else if($(this).scrollTop() <= 95){
                    $('.fixed-sub-nav').css({
                        'position':'relative',
                        'z-index':'1'
                    });
                    //$('.fixed-sub-nav>.custom-sub').css('height','145px');
                    //$('ul.sub-menu').css('margin-top','30px');
                    if($('.sub-page-header').length){
                        $('.sub-page-header').css('margin-top','0');
                    }else{
                        $('.dynamic-content').css('margin-top','0');
                    }
                    //$('.fixed-sub-nav .custom-sub i.snicon').css('font-size','50px');
                }

                if($(this).scrollTop() >= 200){
                    $('.back-to-top').fadeIn();
                }else if($(this).scrollTop() <= 200){
                    $('.back-to-top').fadeOut();
                }
            });

        }

        //Animate Scroll to elements
        $('.fixed-sub-nav a[href^="#"], .back-to-top a').on('click',function (e) {
        	//e.preventDefault();
            var target = this.hash;
            var $target = $(target);

            $('html, body').stop().animate({
                'scrollTop': $target.offset().top - 130
            }, 500, 'swing', function () {
                window.location.hash = target;
            });
            $('h1,h2,h3,h4').css('outline','none');
            $('header').css('outline','none');
        });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
        $('.home-main-slideshow').cycle({
          slides:"> div.home-slide",
          //overlayTemplate: '<h1>{{title}}</h1><h3>{{desc}}</h3>',
          //pagerTemplate:'<span>l</span>',
          timeout: 5000,
          log: false
        });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
        $('.cycle-overlay').each(function() {
          $(this).css('margin-top', '-' + $(this).height());
        });
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    // Fiber One
    'fiber_one': {
    
      init: function() {
          "use strict";
          
          $('.show-more-features').click(function(e) {
              e.preventDefault();
              $('.more-features').slideDown(500, function() {
                $('.show-more-features').parents('p').slideUp();
              });
            });
          
        $('.slider-for').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          fade: true,
          asNavFor: '.slider-nav'
        });


        $('.slider-nav').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          asNavFor: '.slider-for',
          vertical: true,
          dots: false,
          centerMode: false,
          focusOnSelect: true,
          arrows: false
        });



        $('.slider').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          fade: false,
        });

        var is_webkit = navigator.userAgent.toLowerCase().indexOf( 'webkit' ) > -1,
	    is_opera  = navigator.userAgent.toLowerCase().indexOf( 'opera' )  > -1,
	    is_ie     = navigator.userAgent.toLowerCase().indexOf( 'msie' )   > -1;

    	if ( ( is_webkit || is_opera || is_ie ) && document.getElementById && window.addEventListener ) {
    		window.addEventListener( 'hashchange', function() {
    			var id = location.hash.substring( 1 ),
    				element;

    			if ( ! ( /^[A-z0-9_-]+$/.test( id ) ) ) {
    				return;
    			}

    			element = document.getElementById( id );

    			if ( element ) {
    				if ( ! ( /^(?:a|select|input|button|textarea)$/i.test( element.tagName ) ) ) {
    					element.tabIndex = -1;
    				}

    				element.focus();
    			}
    		}, false );
    	}

      }
    },
    // Fiber Edge
    'fiber_edge': {
      init: function() {
        // JavaScript to be fired on the about us page
        $('.show-more-features').click(function(e) {
          e.preventDefault();
          $('.more-features').slideDown(500, function() {
            $('.show-more-features').parents('p').slideUp();
          });
        });
      }
    },
    // Fiber Plus
    'fiber_plus': {
      init: function() {
        // JavaScript to be fired on the about us page
        $('.show-more-features').click(function(e) {
          e.preventDefault();
          $('.more-features').slideDown(500, function() {
            $('.show-more-features').parents('p').slideUp();
          });
        });
      }
    },
    // Fiber Edge
    'fiber_pro': {
      init: function() {
        // JavaScript to be fired on the about us page
        $('.show-more-features').click(function(e) {
          e.preventDefault();
          $('.more-features').slideDown(500, function() {
            $('.show-more-features').parents('p').slideUp();
          });
        });
      }
    },
    // For map on our network page
    'our_network': {
      init: function() {

        function closeSlide(key) {
          $('area').mapster('deselect');
          $('.region').fadeOut('fast', function() {
            $('> li', this).hide();
          });
        }

        function openSlide(key) {
          $('.region > li').hide();
          $('.region').show();
          $('#' + key).fadeIn();
        }

        jQuery(document).ready(function() {

          var currentKey;

          jQuery('#map').mapster({
            singleSelect: true,
            render_highlight: {
              altImage: '../../wp-content/themes/sinet/dist/images/coverage/map2.png'
            },
            mapKey: 'state',
            fill: true,
            altImage: '../../wp-content/themes/sinet/dist/images/coverage/map2.png',
            fillOpacity: 1,
            onClick: function(event) {
              currentKey = event.key;
              openSlide(currentKey);
            }
          });

          jQuery('.slide-nav .close-slide').click(function(event) {
            closeSlide(currentKey);
            event.preventDefault();
          });

          // Hide article on click outside
          jQuery(document).on('click', function(event) {
            if (!jQuery(event.target).closest('#cambodia-map').length && jQuery(window).width() >= 768) {
              closeSlide(currentKey);
            }
          });
          

          // [MOBILE] Show regions when click on title
          jQuery('.region li h3').on('click', function(event) {
            if (jQuery(window).width() < 768) {
              jQuery(this).next().fadeToggle();
            }
          });

          // Prevent closing the article when clicking inside
          jQuery('.region li').on('click', function(event) {
            event.stopPropagation();
          });

          jQuery('.slide-nav .next').click(function(event) {
            event.preventDefault();
            var next = jQuery(this).closest('li').next();
            if (!next.length) {
              next = jQuery(this).closest('ul').find('> li:first');
            }
            var nextId = next.attr('id');

            jQuery('area[state=' + nextId + ']').mapster('select');
            openSlide(nextId);
            currentKey = nextId;
          });

          jQuery('.slide-nav .prev').click(function(event) {
            event.preventDefault();
            var prev = jQuery(this).closest('li').prev();
            if (!prev.length) {
              prev = jQuery(this).closest('ul').find('> li:last');
            }
            var prevId = prev.attr('id');

            jQuery('area[state=' + prevId + ']').mapster('select');
            openSlide(prevId);
            currentKey = prevId;
          });
        });
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };
  
  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
